import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "addEditInvoice",
  templateUrl: "./addEdittextileInvoice.html",
})
export class AddEdittextileInvoiceComponent {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  seasonList: any;
  widthList: any[];
  execApi: boolean = true;

  invoicedata: any = {
    rate_type: "",
    invoice_type: "",
    corcharge: 0,
    boxless: 0,
    taxper: 0,
    disper: 0,
    salesorder: false,
    rate: 0,
    no_of_bundles: 0,
    remarks: "",
  };
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  invoiceTypeList = ["PROFORMA", "INVOICE"];
  rateTypeList = ["FLAT RATE", "DISCOUNT"];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  isvisible: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  partyList: any;
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.sale_type = val["sale_type"];
    this.to_sale_type = val["to_sale_type"];
    this.saveEvent = val["data"].tabevent;
    let invoicedata = Object.assign({}, val["data"]);
    this.invoicedata = invoicedata;
    this.invoicedata.disper = invoicedata.disper;
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (
      this.mode == "View" ||
      this.mode == "Edit"
    )
    
    {
    
        this.invoicedata.barcode = "";
      this.invoicedata.boxless = Number(this.invoicedata.boxless);
      this.editInvoiceList();
     
      //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) {
    this.row = {
      barcode: 0,
      design_no: "",
      rate: 0,
      color: "",
      width: "",
      qty: 0,
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    
    this.getSeason();
    this.tableScroll();
    this.invoicedata.mode = this.mode;
    

    if (this.mode == "Add") {
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");

      this.invoicedata.boxless = 0;
      this.invoicedata.no_of_bundles = 0;

      // this.getAutoNumber();
      //this.getAuto();
    }
  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length >= 1) {
          if (that.box == "YES") {
            that.invoicedata.boxless -= 10;
          }
          that.data.invoiceList.splice(ind, 1);
          that.calctot();
          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (this.listSelected[k].barcode == all.data.invoiceList[ind].barcode) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getInwNumber(inv_type) {
    let type = "";
    if (inv_type == "PROFORMA") {
      type = "textileProforma";
    } 
    else {
      type = "textileRetail";
    }
    let params = {
      trans_type: type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };

    this.salesinvservice.getAutoNumber(params).then((res: any) => {
      this.invoicedata.invoiceno = res.auto_no;
    });
  }


  getSeason() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      date: this.datePipe.transform(new Date(), "yyyy"),
      type: "invoice",
    };
    this.salesinvservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.partyCtrl.setValue(this.invoicedata["season"]);
        this.invoicedata.season = res.data.season;
        this.invoicedata.season_id = res.data.season_id;
      } else {
        swal("PLEASE PUT THE SEASON FIRST!");
      }
    });
  }
  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  checkBarcode(code) {
    if (code.length == 6) {
      if (this.execApi) {
        this.execApi = false;

        let params = {
          barcode: code,
        };
        for (let i = 0; i < this.data.invoiceList.length; i++) {
          // code = parseInt(code);
          // this.data.invoiceList[i].barcode = parseInt(
          //   this.data.invoiceList[i].barcode
          // );
          if (this.data.invoiceList[i].barcode == code) {
            setTimeout(() => {
              this.invoicedata.barcode = "";
              $("#code").focus();
            }, 500);

            swal({
              title: "Barcode Already Exists",
              timer: 1000,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.execApi = true;
            return;
          }
        }

        this.salesinvservice.checkTextilecode(params).then((res: any) => {
          console.log(res.data);
          if (res.data.qty == 0) {
            swal({
              title: "Selected Design is invalid",
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000,
            });
            let invalidData = {
              barcode: code,
              type: "invoice",
            };
            this.invalidList.push(invalidData);
            this.invoicedata.barcode = "";
            this.execApi = true;
            return;
          }
          console.log(res.data);
          let row = Object.assign(
            {
              barcode: 0,
              design_no: "",
              rate: 0,
              color: "",
              width: "",
              qty: 0,
            },
            res.data
          );

           if(this.invoicedata.rate_type == "FLAT RATE"){
            row.rate = this.invoicedata.rate;

           }

          this.data.invoiceList.push(row);
          console.log(this.data.invoiceList);
          var bottom = document.querySelector("#salesTbody");
          setTimeout(() => {
            bottom.scrollTop = bottom.scrollHeight;
          }, 300);

          this.calcBox();
          this.calctot();
          this.execApi = true;
          this.invoicedata.barcode = "";
        });
      }
    }
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.invoicedata.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  oncheckemptyrow() {
   
    let design = this.data.invoiceList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.invoiceList = desList;

    this.onSaveInvoice();
  }

  onSaveInvoice(): void {
    if (
      !this.invoicedata.invoice_type ||
      !this.invoicedata.season || 
      !this.invoicedata.customer_name || 
      !this.invoicedata.rate_type || 
      !this.invoicedata.remarks 
    ) {
      swal("Make sure that the party name, order.no or season entered");
    }
    
 
    
    
    else {
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["boxless"] = this.invoicedata.boxless || 0;
      params["no_of_bundles"] = this.invoicedata.no_of_bundles || 0;
      params["salesorder"] = this.invoicedata.salesorder || false;
      params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
      if (this.mode == "Convert") {
        params["estinvoice"] = JSON.stringify(this.listSelected);
      }

      params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
      if (this.invoicedata.mode == "Convert") {
        params["mode"] = "Add";
        params["estimate_dcid"] = this.invoicedata.dcid;
        params["sales_type"] = this.to_sale_type;
      }

      let that = this;

      swal({
        title: "Are you sure to save this Invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.salesinvservice
          .saveUpdateTextileInvoice(params)
          .then(function (res: any) {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              if (that.mode == "Restore") {
                swal("Sorry! You can only restore the last invoice...");
              } else {
                swal("ERROR", res.message, "error");
              }
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
  calcBox() {
    if (this.box == "YES") {
      this.invoicedata.boxless += 10;
    }
  }
  onSelectInvoiceType(type) {
    if (type == "INVOICE") {
      this.invoicedata.taxper = 5;
      this.invoicedata.sales_type = "retail";
    } else {
      this.invoicedata.taxper = 0;
      this.invoicedata.sales_type = "proforma";
    }
    this.getInwNumber(type);
  }

  editInvoiceList() {
    let params = {
      dcid: this.invoicedata.dcid,
    };
    this.salesinvservice.gettextileInvoiceDet(params).then((res: any) => {
      this.data.invoiceList = res.data;
      this.calctot();
      var bottom = document.querySelector("#salesTbody");
      bottom.scrollTop = bottom.scrollHeight;
    });
  }

  calctot() {
    let ftot = 0,
      tot = 0;
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      tot += parseFloat(this.data.invoiceList[i]["qty"]);
      this.invoicedata.total = tot;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesInvoice/addEdittextileInvoice.ts